<template>
  <div
    class="container educateResult_container"
    :style="{ height: gaojingjian ? '110%' : '100%' }"
  >
    <div class="fx-content">
      <!-- 统计日期 -->
      <div class="select-tit">统计日期</div>
      <el-date-picker
        v-model="startDate"
        type="date"
        class="data-picker"
        placeholder="开始日期"
        @change="getStartDate"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
      ></el-date-picker>
      <el-date-picker
        v-model="endDate"
        type="date"
        class="data-picker"
        placeholder="结束日期"
        @change="getEndDate"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
      ></el-date-picker>
      <!-- 学院范围多选 -->
      <div class="select-tit" style="margin-left: 0.2rem">学院范围</div>
      <el-select
        v-model="scopeValue"
        placeholder="请选择"
        multiple
        collapse-tags
      >
        <el-option
          v-for="item in colldge"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        ></el-option>
      </el-select>
      <!-- 年级范围多选 -->
      <div class="select-tit" style="margin-left: 0.2rem">年级范围</div>
      <el-select
        v-model="gradeValue"
        placeholder="请选择"
        multiple
        collapse-tags
      >
        <el-option
          v-for="item in entryYear"
          :key="item"
          :label="item"
          :value="item"
        ></el-option>
      </el-select>
      <div
        class="btn"
        @click="getSelect"
        :style="{ background: gaojingjian ? '#ed6b00' : 'rgb(0,127,65)' }"
      >
        运算
      </div>
      <quit></quit>
    </div>
    <div
      class="echarts-box"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0)"
    >
      <div class="title">
        在{{ dimension }}个维度上，总共为学生提升能力
        <span class="improvement">{{ total.toFixed(0) }}</span
        >点,人均提升 <span class="Promote">{{ average.toFixed(0) }}</span
        >点
      </div>
      <div class="title2">
        <div class="box-s">
          <div
            class="title2-box"
            :style="{
              background: gaojingjian
                ? 'rgba(237, 107, 0, 0.5)'
                : 'rgba(0, 127, 65, 0.5)',
            }"
          ></div>
          <div>期初平均能力点</div>
        </div>
        <div class="box-s">
          <div
            class="title2-box"
            style="margin-left: 10px; background: #ed6b00"
            :style="{
              marginLeft: '10px',
              background: gaojingjian ? 'rgb(237, 107, 0)' : 'rgb(0,127,65)',
            }"
          ></div>
          <div>期末平均能力点</div>
        </div>
      </div>
      <div class="imgTable-box" v-if="myChartArr && myChartArr.length > 0">
        <div class="img-box">
          <p class="canvas_title">学生能力增长情况</p>
          <div
            id="chart_example"
            :style="{
              height: '750px',
              width: myChartArr.length * 100 - 150 + 'px',
              flexShrink: 0,
              background: '#fff',
            }"
          ></div>
        </div>
        <div class="table-box">
          <div class="tit" v-if="gaojingjian">
            <p>课程供给</p>
            <p>
              <span class="iconfont iconketang" style="margin-right: 10px"
                >开课</span
              ><span class="iconfont iconrengong">人次</span>
            </p>
          </div>
          <div
            class="table"
            :style="{ width: myChartArr.length * 100 - 180 + 'px' }"
            v-if="gaojingjian"
          >
            <div
              v-for="(item, index) in myChartArr"
              :key="index"
              class="table-item"
            >
              <p class="iconfont iconketang" style="margin-bottom: 10px">
                {{ item.course_number }}
              </p>
              <p class="iconfont iconrengong">{{ item.people_times }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
export default {
  name: "studentPortrayal",
  data() {
    return {
      startDate: null,
      endDate: null,
      scopeValue: "",
      gradeValue: "",
      colldge: [],
      entryYear: [],
      dimension: "",
      total: "",
      average: "",
      myChartArr: [],
      loading: false,
      gaojingjian: false,
    };
  },
  components: {},
  created() {
    this.dropDown();
    this.getSelect();
  },
  mounted() {},
  methods: {
    // 获取下拉框的数据
    dropDown() {
      this.$api.common
        .getdropdown()
        .then((res) => {
          if (res.data.statusCode == 200) {
            this.colldge = res.data.data.college;
            this.entryYear = res.data.data.entryYear;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 点击运算，获取新的学生能力增长情况
    getSelect() {
      this.loading = true;
      var _this = this;
      let params = {
        timeStart: this.startDate,
        timeEnd: this.endDate,
        colleges: this.scopeValue,
        entryYears: this.gradeValue,
      };
      console.log(params);
      this.$api.common
        .postCharts(params)
        .then((res) => {
          if (res.data.statusCode == 200) {
            this.loading = false;
            // 获取维度
            this.dimension = res.data.data.dimension;
            // 总共为学生提升能力
            this.total = res.data.data.total;
            // 人均提升
            this.average = res.data.data.average;
            // echarts图表数据
            this.myChartArr = res.data.data.chart;
            setTimeout(function () {
              _this.getEcharts(_this.myChartArr);
            }, 500);
          } else {
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getStartDate() {},
    getEndDate() {},

    getEcharts(myChartArr) {
      let studentsAbilityTitles = [];
      let studentsAbilityData1 = [];
      let studentsAbilityData2 = [];
      myChartArr.forEach((el) => {
        if (Number(el.upgrade) == 0) {
          studentsAbilityData2.push("");
        } else {
          if (el.upgrade.toString().split(".")[1].length > 2) {
            studentsAbilityData2.push(
              Number(el.upgrade).toFixed(2) > 0
                ? Number(el.upgrade).toFixed(1)
                : 0.1
            );
          } else {
            studentsAbilityData2.push(Number(el.upgrade).toFixed(1));
          }
        }
        studentsAbilityTitles.push(el.title);
        if (el.initial.toString().split(".")[1].length > 2) {
          studentsAbilityData1.push(
            Number(el.initial).toFixed(2) > 0
              ? Number(el.initial).toFixed(1)
              : 0.1
          );
        } else {
          studentsAbilityData1.push(Number(el.initial).toFixed(1));
        }
      });
      var color1 = "rgba(237,107,0,.5)",
        color2 = "#ED6B00";
      if (!this.gaojingjian) {
        color1 = "rgba(0,127,65,.5)";
        color2 = "rgb(0,127,65)";
      }
      console.log(studentsAbilityData1);
      console.log(studentsAbilityData2);
      var fontColor = "#30eee9";
      let myChart = echarts.init(document.getElementById("chart_example"));
      let option = {
        legend: {
          type: "scroll",
          right: "4%",
          top: "0%",
          itemWidth: 10,
          textStyle: {
            color: "#2A2E3D",
          },
        },
        tooltip: {
          axisPointer: {
            type: "",
          },
          //去掉了柱状图的阴影
          showContent: false,
        },
        grid: {
          borderWidth: 0,
          show: true,
          left: "30px",
          right: "0px",
          textStyle: {
            color: "#2A2E3D",
          },
        },
        xAxis: [
          {
            type: "category",
            data: studentsAbilityTitles,
            splitLine: {
              show: true,
              lineStyle: {
                // 使用深浅的间隔色
                show: false,
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#F0F2F5",
                type: "solid",
              },
            },
            axisLabel: {
              formatter: function (params) {
                var newParamsName = "";
                var paramsNameNumber = params.length;
                var provideNumber = 2; // 每行能显示的字的个数
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                if (paramsNameNumber > provideNumber) {
                  /** 循环每一行,p表示行 */
                  for (var p = 0; p < rowNumber; p++) {
                    var tempStr = ""; // 表示每一次截取的字符串
                    var start = p * provideNumber; // 开始截取的位置
                    var end = start + provideNumber; // 结束截取的位置
                    // 此处特殊处理最后一行的索引值
                    if (p == rowNumber - 1) {
                      // 最后一次不换行
                      tempStr = params.substring(start, paramsNameNumber);
                    } else {
                      // 每一次拼接字符串并换行
                      tempStr = params.substring(start, end) + "\n";
                    }
                    newParamsName += tempStr;
                  }
                } else {
                  newParamsName = params;
                }
                return newParamsName;
              },
              margin: 20,
              textStyle: {
                color: "rgba(42,46,61,.76)",
                fontSize: "14",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              formatter: "V{value}",
              textStyle: {
                color: "#999EB3",
                fontSize: "14",
              },
            },
            axisLine: {
              show: false,
              lineStyle: {
                show: false,
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#F0F2F5",
                type: "solid",
              },
            },
            min: 0,
            max: 9,
            splitNumber: 9,
            minInterval: 1,
          },
        ],
        series: [
          {
            name: "",
            type: "bar",
            barWidth: "60%",
            stack: "one",
            data: studentsAbilityData1,
            // barWidth:30,
          },
          {
            name: "",
            type: "bar",
            barWidth: "60%",
            stack: "one",
            data: studentsAbilityData2,
            label: {
              show: true,
              position: "top",
              formatter: "+{@+}",
              fontSize: 18,
            },
            itemStyle: {
              normal: {
                //柱形图圆角，鼠标移上去效果
                emphasis: {
                  barBorderRadius: [5, 5, 0, 0],
                },
                barBorderRadius: [5, 5, 0, 0],
              },
            },
          },
        ],
        color: [color1, color2],
      };
      myChart.on("legendscroll", function (param) {
        console.log(param);
      });
      myChart.setOption(option);
      window.onresize = myChart.resize;
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #f5f6fa;
  .echarts-box {
    width: 100%;
    height: 750px;
    position: relative;
    // padding-top: 30px;
    min-height: 500px;
    .title {
      position: absolute;
      top: 32px;
      color: #7c829d;
      font-size: 16px;
      left: 1%;
      z-index: 1;
      .improvement {
        color: #2a2e3d;
        padding: 0 5px;
        font-size: 18px;
      }
      .Promote {
        color: #2a2e3d;
        padding: 0 5px;
        font-size: 18px;
      }
    }
  }
  /* 运算 */
  .fx-content {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 0.12rem;
    // margin-right: 0.2rem;
  }
  .select-tit {
    width: 80px;
    height: 39px;
    line-height: 39px;
    font-size: 12px;
    color: #7c829d;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    margin-right: 1px;
  }
  ::v-deep .el-input__inner {
    background-color: #fff;
    border: none;
    border-radius: 0;
    color: #7c829d;
  }
}
.btn {
  color: #fff;
  border-radius: 4px;
  background: #ed6b00;
  width: 75px;
  text-align: center;
  height: 40px;
  line-height: 39px;
  margin-left: 15px;
  font-size: 14px;
  cursor: pointer;
}
::v-deep canvas {
  top: 40px !important;
}

.canvas_title {
  font-size: 20px;
  margin-top: 25px;
  color: #2a2e3d;
  font-weight: bold;
  width: 130px;
  flex-shrink: 0;
  writing-mode: vertical-rl;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 50px;
  letter-spacing: 7px;
}
.table {
  display: flex;
  align-items: center;
  // padding-right: 50px;
  flex-shrink: 0;
  div {
    width: 100%;
  }
}
.imgTable-box {
  overflow-x: auto;
    background: #fff;
    margin-top: 14px;
}
.table-box {
  display: flex;
  align-items: center;
  margin-top: 50px;
  .tit {
    width: 160px;
    height: 80px;
    background-color: #fff;
    flex-shrink: 0;
    margin-right: 2px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .iconfont {
      color: #999eb3;
      font-size: 12px !important;
    }
    .iconfont:before {
      margin-right: 5px;
    }
    p:first-child {
      font-size: 16px !important;
      color: #2a2e3d;
      margin-bottom: 10px;
    }
  }
}
.img-box {
  display: flex;
  align-items: center;
  background: #fff;
  margin-top: 16px;
}
.table-item {
  background-color: #fff;
  color: #3b6fe8;
  text-align: center;
  height: 80px;
  margin-right: 2px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .iconfont:before {
    color: #999eb3;
    font-size: 12px !important;
    margin-right: 5px;
  }
}
.title2 {
  position: absolute;
  right: 1%;
  color: #2a2e3d;
  display: flex;
  align-items: center;
  top: 42px;
  z-index: 2;
  .title2-box {
    width: 12px;
    height: 12px;
    background: rgba(237, 107, 0, 0.5);
    margin-right: 5px;
  }
}
.box-s {
  display: flex;
  align-items: center;
  color: #7c829d;
}
.educateResult_container {
  padding: 40px;
  height: 100%;
}
::v-deep .el-loading-spinner i {
  color: #ed6b00;
}
::v-deep .el-loading-spinner .el-loading-text {
  color: #ed6b00;
}
</style>